export default __webpack_public_path__ + "static/media/Blooded Helm of the Mound.862412f2.jpg";